import interestsService from '../../services/api/user-interests'
import { useQuery } from 'react-query'
import STALE_TIMES from '../common/stale-times'
import useCacheKeys from '../use-cache-keys'

const useUserInterests = ({
    userId,
}) => {
    const cacheKeys = useCacheKeys()

    const { data, isLoading, isFetching } = useQuery([cacheKeys.USER_INTERESTS, userId], () => interestsService.fetch({ userId }), {
        enabled: Boolean(userId),
        staleTime: STALE_TIMES.HOUR,
    })

    return {
        isLoading: isLoading || isFetching,
        userInterests: data ? data.items : [],
    }
}

export default useUserInterests